import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import "../../styles/dashboard/dashboard.css";
import Header from "../../components/header/Header";
import InfoCard from "../../components/cards/InfoCard";
import ProgressBar from "../../components/progressbar/ProgressBar";
import MapComponent from "../../components/maps/MapComponent";
import "../../styles/cards/card.css";
import Cookies from "js-cookie";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CoordinatorSupervisorDashboard = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [indexRecordStats, setIndexRecordStats] = useState({
    totalIndexed: 0,
    approved: 0,
  });
  const [loadingCards, setLoadingCards] = useState(true);
  const [error, setError] = useState(null);
  const [scannedRecordStats, setScannedRecordStats] = useState({
    totalScanned: 0,
    totalBooks: 0,
    approvedBooks: 0,
    approved: 0,
  });
  const [yellowFormStats, setYellowFormStats] = useState({
      totalScanned: 0,
      totalForms: 0,
      approvedForms: 0,
      approved: 0,
    });
  const [loading, setLoading] = useState(true);
  const [sectors, setSectors] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const totalBooks = process.env.REACT_APP_TOTAL_BOOKS;
  const totalRecords = process.env.REACT_APP_TOTAL_RECORDS;

  useEffect(() => {
    // Fetch indexed records stats

    const fetchIndexedRecordsStats = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/index/indexed-records/total-stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setIndexRecordStats(res.data);
      } catch (error) {
        setError("Failed to load index records total stats");
      } finally {
        setLoadingCards(false);
      }
    };

    const fetchScannedRecordsStats = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/scanned/scanned-records/total-stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setScannedRecordStats(res.data);
      } catch (error) {
        setError("Failed to load scanned records total stats");
      } finally {
        setLoadingCards(false);
      }
    };

    const fetchScannedYellowFormStats = async () => {
          try {
            const token = Cookies.get("token");
            const res = await axios.get(
              `${baseUrl}/api/yellow-forms/total-stats`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            setYellowFormStats(res.data);
          } catch (error) {
            setError("Failed to load site data");
          } finally {
            setLoadingCards(false);
          }
        };



    fetchIndexedRecordsStats();
    fetchScannedRecordsStats();
    fetchScannedYellowFormStats();
  }, [baseUrl]);

  useEffect(() => {
    const fetchLatestScannedSites = async () => {
      try {
        const token = Cookies.get("token");
        const endpoint =
          activeTab === "approved"
            ? `${baseUrl}/api/sites/latest-sites/approved`
            : `${baseUrl}/api/sites/latest-sites/all`;
        const res = await axios.get(endpoint, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSectors(res.data);
      } catch (err) {
        setError("Failed to load latest scanned sites");
      } finally {
        setLoading(false);
      }
    };

    fetchLatestScannedSites();
  }, [baseUrl, activeTab]);

  const renderSkeletonCards = () => {
    return Array(3)
      .fill()
      .map((_, index) => (
        <div key={index} className="card" style={{ minWidth: "300px" }}>
          <div className="card-header">
            <Skeleton width={250} height={12} />
            <Skeleton width={60} height={40} />
          </div>
          <div className="line"></div>
          <div className="card-content">
            <div className="progress-bar-container">
              <Skeleton width="100%" height={10} />
              <Skeleton width={80} height={12} style={{ marginTop: "11px" }} />
            </div>
          </div>
        </div>
      ));
  };

  return (
    <>
      <div className="dashboard-container">
        <Sidebar role="supervisor" />
        <div className="main-content">
          <Header />
          <div className="dashboard-content coordinator">
            <div className="tabs">
              <div
                className={`tab ${activeTab === "all" ? "active" : ""}`}
                onClick={() => setActiveTab("all")}
              >
                All Data
              </div>
              <div
                className={`tab ${activeTab === "approved" ? "active" : ""}`}
                onClick={() => setActiveTab("approved")}
              >
                Approved Data
              </div>
            </div>
            <div className="dashboard-cards">
              {loadingCards ? (
                renderSkeletonCards()
              ) : (
                <>
                  <InfoCard
                    value={
                      activeTab === "approved"
                        ? `${indexRecordStats.approved}/${totalRecords}`
                        : `${indexRecordStats.totalIndexed}/${totalRecords}`
                    }
                    title="INDEXED RECORDS"
                    fetchDetails={activeTab === "approved" ? 
                      () =>
                        axios.get(
                          `${baseUrl}/api/index/indexed-records/stats/details`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                      : () => 
                        axios.get(
                          `${baseUrl}/api/index/indexed-records/stats/details/coordinator`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                    }
                  />
                  <InfoCard
                    value={
                      activeTab === "approved"
                        ? `${scannedRecordStats.approvedBooks}/${totalBooks}`
                        : `${scannedRecordStats.totalBooks}/${totalBooks}`
                    }
                    title="SCANNED BOOKS"
                    fetchDetails={activeTab === "approved" ? 
                      () =>
                        axios.get(
                          `${baseUrl}/api/scanned/scanned-records/stats/details`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                      : () => 
                        axios.get(
                          `${baseUrl}/api/scanned/scanned-records/stats/details/coordinator`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                    }
                  />
                  <InfoCard
                    value={
                      activeTab === "approved"
                        ? `${yellowFormStats?.approved}`
                        : `${yellowFormStats?.totalScanned}`
                    }
                    title="SCANNED YELLOW FORMS"
                    fetchDetails={activeTab === "approved" ? 
                      () =>
                        axios.get(
                          `${baseUrl}/api/yellow-forms/stats/details`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                      : () => 
                        axios.get(
                          `${baseUrl}/api/yellow-forms/stats/details/coordinator`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                    }
                  />
                  <InfoCard
                    value={
                      activeTab === "approved"
                        ? `${scannedRecordStats.approved}/${totalRecords}`
                        : `${scannedRecordStats.totalScanned}/${totalRecords}`
                    }
                    title="ESTIMATED SCANNED RECORDS"
                    fetchDetails={activeTab === "approved" ? 
                      () =>
                        axios.get(
                          `${baseUrl}/api/scanned/scanned-records/stats/details`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                      : () => 
                        axios.get(
                          `${baseUrl}/api/scanned/scanned-records/stats/details/coordinator`,
                          {
                            headers: {
                              Authorization: `Bearer ${Cookies.get("token")}`,
                            },
                          }
                        )
                    }
                  />
                </>
              )}
            </div>

            <div className="demographic-data">
              <div className="title">Situation Map</div>
              <div className="content">
                <MapComponent activeTab={activeTab} />
                {sectors.length > 0 && (
                  <div className="sectors">
                    <div className="title">Latest scanned sites</div>
                    <div className="sector-container">
                      {sectors.map((sector, index) => (
                        <ProgressBar
                          key={index}
                          label={sector.label}
                          value={sector.value}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoordinatorSupervisorDashboard;